export const documentProps = {
  title: 'About Us — DMV Business Automation Experts',
  description:
    'TenK Solutions brings 15+ years of engineering experience to business automation. We are vendor-agnostic, hands-on, and partner with 200+ technology suppliers across the US.',
};
